<template>
  <div class="c_warpper tab-warpper">
    <div class="con_list">
      <div
        v-for="(session, index) in sessionlist"
        class="u-list-item"
        :ref="session.id"
        :inline-desc="session.lastMsgShow"
        :key="session.id"
        :sessionId="session.id"
        @click="enterChat(session)"
      >
        <div class="_warpper" @mouseout="sessionEnter" @mouseleave="sessionLeave">
          <div class="imgWarpper sess_item">
            <img
              class="icon u-circle"
              slot="icon"
              width="24"
              :src="session.avatar || defalutAvatar"
            />
          </div>
          <div class="text sess_item">
            <span class="u-session-name">{{session.name}}</span>
            <div class="u-session-msg">{{session.lastMsgShow}}</div>
          </div>
          <div class="unreadWarpper sess_item">
            <span class="u-session-time">{{session.updateTimeShow}}</span>
            <span v-show="session.unread > 0" class="u-unread">{{session.unread}}</span>
          </div>
          <span class="delIcon hide" ref="delIcon" @click="delSession($event,session)">
            <img src="../../../assets/images/icon_del.png" />
          </span>
        </div>
      </div>
      <!-- <div
        v-for="friend in friendslist"
        :key="friend.account"
        class="u-list-item"
        @click="enterChat(friend)"
      >
        <div class="warpper">
          <div class="imgWarpper sess_item">
            <el-image :src="userInfos[friend.account].avatar" fit="cover" style="width: 35px; height: 35px">
              <div slot="error" class="image-slot">
                <el-image style="width: 35px; height: 35px" :src="defalutAvatar" fit="cover"></el-image>
              </div>
            </el-image>
          </div>
          <div class="text sess_item">
            <span class="u-session-name">{{friend.alias}}</span>
          </div>
        </div>
      </div>-->
    </div>
    <div v-if="sessionlist.length==0" class="empty">
      <emptyData />
    </div>
  </div>
</template>

<script>
import util from "@/utils/index.js";
import config from "@/config/config.js";
import emptyData from "@/components/common/emptyData.vue";
export default {
  name: "",
  components: { emptyData },
  props: {},
  data() {
    return {
      superMan: "p2p-21232f297a57a5a743894a0e4a801fc3",
      sessions: [],
      defalutAvatar: config.defaultUserIcon
    };
  },
  created() {},
  mounted() {
    console.log("myInfo:", this.$store.state.myInfo);
  },
  activited() {},
  beforeRouteUpdate() {},
  methods: {
    enterChat(session) {
      let query = {
        sessionId: session.id
      };
      if (session.id) {
        this.$router.push({
          path: "/index/work/chart",
          query
        });
      } else {
        this.$message({
          type: "error",
          message: "当前会话已删除"
        });
      }
    },
    //删除session
    delSession(e,session) {
      event.stopPropagation();
      // this.$store.dispatch("delLocalSession", session.id);
      this.$confirm('确定要删处该会话吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteHandle(session)
      })
    },
    deleteHandle(session){
      let that = this;
      let nim = that.$store.state.nim;
      nim.deleteLocalSession({
        id: session.id,
        done: deleteLocalSessionDone
      });
      function deleteLocalSessionDone(error, obj) {
        if (!error) {
          that.$refs[session.id][0].classList.add("hide");
          that.$message({
            type: "success",
            message: "会话删除成功"
          });
          // commit("delSession", obj.id);
        } else {
          that.$message({
            type: "error",
            message: "会话删除失败"
          });
        }
      }
    },
    //鼠标滑过session
    sessionEnter($event) {
      var delNode = this.getDelNode($event);
      if (delNode) {
        var delStr = delNode.classList.value;
        if (delStr.indexOf("hide") != -1) {
          delNode.classList.remove("hide");
        }
      }
    },
    sessionLeave($event) {
      var delNode = this.getDelNode($event);
      if (delNode) {
        var delStr = delNode.classList.value;
        if (delStr.indexOf("hide") == -1) {
          delNode.classList.add("hide");
        }
      }
    },
    getDelNode($event) {
      var childNodes = $event.fromElement.childNodes;
      var delNode = "";
      childNodes.forEach(item => {
        if (item.classList) {
          var str = item.classList.toString();
          if (str.indexOf("delIcon") != -1) {
            delNode = item;
          }
        }
      });
      return delNode;
    }
  },
  filter: {},
  computed: {
    delSessionId() {
      // console.log("delSessionId:", this.$store.state.delSessionId);
      return this.$store.state.delSessionId;
    },
    friendslist() {
      return this.$store.state.friendslist.filter(item => {
        let account = item.account;
        let thisAttrs = this.userInfos[account];
        let alias = thisAttrs.alias ? thisAttrs.alias.trim() : "";
        item.alias = alias || thisAttrs.nick || account;
        item.link = `/namecard/${item.account}`;
        if (!thisAttrs.isFriend || thisAttrs.isBlack) {
          return false;
        }
        return true;
      });
    },
    userInfos() {
      return this.$store.state.userInfos;
    },
    myInfo() {
      return this.$store.state.myInfo;
    },
    sessionlist() {
      let sessionlist = this.$store.state.sessionlist.filter(item => {
        item.name = "";
        item.avatar = "";
        if (item.scene === "p2p") {
          let userInfo = null;
          if (item.to !== this.myPhoneId) {
            userInfo = this.userInfos[item.to];
          } else {
            // userInfo = this.myInfo
            // userInfo.alias = '我的手机'
            // userInfo.avatar = `${config.myPhoneIcon}`
            return false;
          }
          if (userInfo) {
            item.name = util.getFriendAlias(userInfo);
            item.avatar = userInfo.avatar;
          }
        } else if (item.scene === "team") {
          let teamInfo = null;
          teamInfo = this.$store.state.teamlist.find(team => {
            return team.teamId === item.to;
          });
          if (teamInfo) {
            item.name = teamInfo.name;
            item.avatar =
              teamInfo.avatar ||
              (teamInfo.type === "normal"
                ? this.myGroupIcon
                : this.myAdvancedIcon);
          } else {
            item.name = `群${item.to}`;
            item.avatar = item.avatar || this.myGroupIcon;
          }
        }
        let lastMsg = item.lastMsg || {};
        if (lastMsg.type === "text") {
          item.lastMsgShow = lastMsg.text || "";
        } else if (lastMsg.type === "custom") {
          item.lastMsgShow = util.parseCustomMsg(lastMsg);
        } else if (
          lastMsg.scene === "team" &&
          lastMsg.type === "notification"
        ) {
          item.lastMsgShow = util.generateTeamSysmMsg(lastMsg);
        } else if (util.mapMsgType(lastMsg)) {
          item.lastMsgShow = `[${util.mapMsgType(lastMsg)}]`;
        } else {
          item.lastMsgShow = "";
        }
        if (item.updateTime) {
          item.updateTimeShow = util.formatDate(item.updateTime, true);
        }
        return item;
      });
      console.log('sessionlist:',sessionlist)
      return sessionlist;
    }
  }
};
</script>

<style lang="scss" scoped>
._warpper {
  display: flex;
  cursor: pointer;
  padding: 8px;
  border-bottom: 1px solid #ccc;
  .sess_item {
    flex: 1;
    overflow: hidden;
  }
  .imgWarpper {
    flex: 0 0 12%;
    padding: 0 5px;
    img {
      width: 100%;
      border-radius: 50%;
    }
  }
  .delIcon img {
    width: 15px;
  }
  .text {
    // flex: 0 0 60%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .u-session-msg {
      font-size: 14px;
      color: #98a7b4;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .unreadWarpper {
    display: flex;
    flex: 0;
    flex-direction: column;
    justify-content: space-around;
    min-width: 45px;
    .u-session-time {
      font-size: 14px;
      color: #98a7b4;
    }
    .u-unread {
      text-align: center;
      background-color: #f24c3d;
      color: #fff;
      border-radius: 50%;
      width: 30px;
      padding: 2px;
    }
  }
}
.empty {
  width: 50%;
  margin: 0 auto;
  margin-top: 50%;
}
</style>
